import React, { useState } from "react";
import { ChevronLeft as Left, ChevronRight as Right } from "react-feather";

interface NumberPagerProps {
  value: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => any;
}

const NumberPager: React.FC<NumberPagerProps> = ({ value, min, max, onChange }) => {

  const change = (value: number) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="d-flex align-items-center">

      {(min ?? value - 1) < value
        ? (<a href={`#${value - 1}`} onClick={(e) => {
          e.preventDefault();
          change(value - 1)
        }}><Left /></a>)
        : (<span className="text-panel-dark"><Left /></span>)}

      <div className="fs-8">{value}</div>

      {value < (max ?? value + 1)
        ? (<a href={`#${value + 1}`} onClick={(e) => {
          e.preventDefault();
          change(value + 1)
        }}><Right /></a>)
        : (<span className="text-panel-dark"><Right /></span>)}

    </div>);
}

export default NumberPager;
